<template lang="pug">
.mb-3.round-xl.border-selected
  .d-flex.align-center.px-4.py-2.neutral300.border-selected-top
    .flex-grow-1
      .d-flex
        .font-semibold.mr-4 {{ getDate }}
      .text-sm(v-if="getDoctorName") {{ $t('attended_by', { who: getDoctorName }) }}
  .white.px-4.pb-2.border-selected-bottom
    template(v-if="getTreatments.length === 0")
      .mt-4.mx-4.mb-2.d-flex.justify-center
        .text-sm.neutral500--text No treatment record
    template(v-else v-for="treatment in getTreatments")
      .d-flex.align-start.my-4.clickable(@click.prevent="onClickSelection(treatment)")
        yc-checkbox.mr-4(v-model="selectedTreatment" :value="treatment" @change="onChange")
        div.grow
          .text-sm.font-semibold.neutral700--text.mb-1 {{ treatment.name }}
          v-row(no-gutters)
            v-col(cols="3")
              .text-xs.font-medium.neutral500--text.mb-1 {{ $t('instruction') }}
            v-col
              .text-xs.font-medium.mb-1 {{ getInstruction(treatment) }}
          v-row(no-gutters)
            v-col(cols="3")
              .text-xs.font-medium.neutral500--text.mb-1 {{ $t('side_effect') }}
            v-col
              .text-xs.font-medium.mb-1 {{ getPrecaution(treatment) }}
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      selectedTreatment: []
    }
  },
  computed: {
    getDate() {
      return DateTime.fromISO(this.parentHistory.record_date).toFormat('dd MMM y')
    },
    getDoctorName() {
      return this.parentHistory?.provider?.name || null
    },
    getTreatments() {
      let treatment = []
      if (this.parentHistory.treatments.length) {
        treatment = this.parentHistory.treatments.filter(f => !['bundle', 'documents'].includes(f.product.type))
      }
      return treatment
    },
  },
  methods: {
    hasValue(value) {
      if (typeof value === 'string') {
        value = value.trim()
      }
      return value !== null && value !== undefined && value !== ''
    },
    getInstruction(item) {
      let result = []
      if (this.hasValue(item.extra_data.dosage_value) && this.hasValue(item.extra_data.dosage_unit)) {
        result.push(`${item.extra_data.dosage_value} ${item.extra_data.dosage_unit}`)
      }
      if (this.hasValue(item.extra_data.frequency)) {
        result.push(item.extra_data.frequency)
      }
      if (this.hasValue(item.extra_data.instruction)) {
        result.push(item.extra_data.instruction)
      }
      return result.length > 0 ? result.join(', ') : '-'
    },
    getPrecaution(item) {
      return item.extra_data.precaution ?? '-'
    },
    onClickSelection(value) {
      if (this.selectedTreatment.includes(value)) {
        this.selectedTreatment = this.selectedTreatment.filter(x => x !== value)
      } else {
        this.selectedTreatment.push(value)
      }
      this.$emit('updated', { data: this.selectedTreatment, pid: this.parentHistory.lead_pid })
    },
    onChange () {
      this.$emit('updated', { data: this.selectedTreatment, pid: this.parentHistory.lead_pid })
    }
  },
};
</script>

<style lang="scss" scoped>
.border-selected {
  border: 1px solid #c1c1c1 !important;
}
.border-selected-top {
  border-radius: 10px 10px 0px 0px;
}
.border-selected-bottom {
  border-radius: 0px 0px 10px 10px;
}
</style>